import React, { useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { parseQuery } from "../../../helper/helper";
import { useLocation } from 'react-router-dom'

export const Context = React.createContext(null);

const initialFilterData = {
  cartId: '',
  ticketId: ''
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        ...action.payload
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  const location = useLocation();
  const openedFromLink = parseQuery(location.search)

  var [state, dispatch] = useReducer(reducer, {
    cartId: openedFromLink.cartId || '',
    ticketId: openedFromLink.ticketId || ''
  });

  useEffect(() => {
    
    const queryObj = parseQuery(location.search);

    if (queryObj.cartId || queryObj.ticketId) {
      dispatch({
        type: 'SUBMIT_FILTER',
        payload: {
          cartId: queryObj.cartId || '',
          ticketId: queryObj.ticketId || ''
        }
      })
    }

  }, [location.search]) // not dependency of state => avoid loop forever

  useEffect(() => {
    document.title = "Vé"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      <Table />
    </Context.Provider>
  );
};
